import { StylistLevel } from 'types/stylist-level';

export default function mapLevelToLabel(level: StylistLevel): string {
  switch (level) {
    case StylistLevel.Elite:
      return 'Elite Stylist';
    case StylistLevel.Junior:
      return 'Junior Stylist';
    case StylistLevel.Master:
      return 'Master Stylist';
  }
}
